import React, { useEffect, useMemo, useRef } from 'react';
import { arrayOf, bool, func, node, object, oneOf, shape, string } from 'prop-types';
import classNames from 'classnames';
import { FieldCustomSelect, InlineTextButton, Modal, ValidationError } from '..';
import css from './FieldReference.module.css';
import { ReactComponent as Verified } from '../../assets/svg/verified.svg';
import {
  defaultPhonecodeCountry,
  employmentType,
  languageSelectOptions,
  workingStatus,
} from '../../marketplace-custom-config';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FieldArray } from 'react-final-form-arrays';
import { BsPlusLg } from 'react-icons/bs';
import { FiEdit3, FiMinus } from 'react-icons/fi';
import { HiOutlineMail } from 'react-icons/hi';
import { ReactComponent as PhoneIcon } from '../../assets/svg/phone.svg';
import { ReferenceForm } from '../../forms';
import { cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { ReactComponent as InfoIcon } from '../../assets/svg/infoIcon.svg';

import { Tooltip as ReactTooltip } from 'react-tooltip';
const customLabel = Object.values(languageSelectOptions).reduce((pre, curnt) => {
  pre[curnt.value] = string.isRequired;
  return pre;
}, {});

const nativeLangOptions = Object.keys(customLabel);

const FieldReferenceComponent = props => {
  const {
    rootClassName,
    className,
    errorClassName,
    titleClassName,
    id,
    name,
    userNativeLang,
    intl,
    formApi,
    formError,
    user,
    fromWorkerQualification,
  } = props;

  const preSavedValues = useRef({});

  const addMoreRef = e => {
    e.preventDefault();
    e.stopPropagation();
    const {
      mutators: { push },
    } = formApi;
    push(name, {
      phoneNumber: defaultPhonecodeCountry,
      isEditMode: true,
      isSavedOnce: false,
      id: uuidv4(),
    });
  };

  const checkAndRemoveRef = (indx, values, e) => {
    e.preventDefault();
    e.stopPropagation();
    const {
      mutators: { remove, update },
    } = formApi;
    const { isSavedOnce = false } = values;
    if (!isSavedOnce) {
      remove(name, indx);
    } else {
      update(name, indx, { ...(preSavedValues.current[indx] || {}), isEditMode: false });
    }
    delete preSavedValues.current[indx];
  };

  const handleRefSave = (indx, values) => {
    const updatedValues = { ...values, isEditMode: false, isSavedOnce: true };
    const {
      mutators: { update },
    } = formApi;
    update(name, indx, updatedValues);
    delete preSavedValues.current[indx];
  };

  const handleRefEdit = (indx, values, event) => {
    event.preventDefault();
    event.stopPropagation();
    const {
      mutators: { update },
    } = formApi;
    const updatedValues = { ...values, isEditMode: true };
    preSavedValues.current[indx] = cloneDeep(updatedValues);
    update(name, indx, updatedValues);
  };

  const addRefBtnLabel = intl.formatMessage({ id: 'FieldReference.addRefBtn' });

  const classes = classNames(rootClassName || css.root, className, {
    [errorClassName]: !!errorClassName && hasError,
  });

  const editBtnLabel = intl.formatMessage({ id: 'FieldWorkerJobExperience.editBtn' });
  const removeBtnLabel = intl.formatMessage({ id: 'FieldWorkerJobExperience.removeBtn' });

  const titleClasses = classNames(css.titleWrapper, titleClassName);

  return (
    <React.Fragment>
      <div className={classes} id={id}>
        <div className={titleClasses}>
          <h2 className={css.heading}>
            <FormattedMessage id="FieldReference.heading" />
          </h2>
          <p className={css.helperText}>
            <FormattedMessage id="FieldReference.subHeading" />
          </p>
        </div>
        <div className={css.referencesDiv}>
          <FieldArray name={name}>
            {({ fields }) => {
              const { value } = fields;
              return fields.map((fieldName, indx) => {
                const savedDetails = value[indx];
                const {
                  isEditMode = true,
                  jobTitle,
                  companyName,
                  firstName,
                  lastName,
                  email,
                  phoneNumber,
                } = savedDetails;
                const fieldArrayFormError = (formError[name] || [])[indx] || {};
                const ReferenceData = user?.attributes?.profile?.publicData?.references
              

                return (
                  <>
                    {isEditMode ? (
                      <div key={`${fieldName}-${indx}`} className={css.formWrapper}>
                        <div className={css.referenceFormOpen}>
                          <div className={css.tooltipDiv}>
                            <span
                              id={`${fieldName}-${indx}-ReferenceTooltip`}
                              className={css.tooltipIcon}
                            >
                              <InfoIcon />
                            </span>

                            <ReactTooltip
                              anchorId={`${fieldName}-${indx}-ReferenceTooltip`}
                              place="top"
                              effect="solid"
                              clickable={false}
                              className={css.categoryTooltip}
                              content={<FormattedMessage id="FieldReference.subHeading" />}
                            />
                          </div>
                          <ReferenceForm
                            name={fieldName}
                            userNativeLang={userNativeLang}
                            onCancel={checkAndRemoveRef.bind(null, indx, savedDetails)}
                            className={css.form}
                            values={savedDetails}
                            onSubmit={handleRefSave.bind(null, indx)}
                            formError={fieldArrayFormError}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className={css.referenceDataDiv} key={`${fieldName}-${indx}`}>
                        <div className={css.heading}>
                          <div className={css.topHeading}>
                            <div>
                              <h3>
                                {firstName} {lastName}
                              </h3>
                            </div>
                            {fromWorkerQualification ? (
                              <>
                          
                                {value[indx]?.isVerified===undefined||value[indx]?.isVerified === false ? (
                                  <>
                                    <div className={css.editRemoveBtnDiv}>
                                      <InlineTextButton
                                        type="button"
                                        onClick={handleRefEdit.bind(null, indx, savedDetails)}
                                      >
                                        <FiEdit3 />
                                        <span>{editBtnLabel}</span>
                                      </InlineTextButton>
                                      <InlineTextButton
                                        type="button"
                                        onClick={checkAndRemoveRef.bind(null, indx, {})}
                                      >
                                        <FiMinus />
                                        <span>{removeBtnLabel}</span>
                                      </InlineTextButton>
                                    </div>
                                  </>
                                ) : (
                                  // <div className={css.editRemoveBtnDiv}>
                                  <span className={css.verifiedTag}>
                                    <Verified />
                                    <FormattedMessage id="WorkerProfileViewPage.verified" />
                                  </span>
                                  // {/* </div> */}
                                )}
                              </>
                            ) : (
                              <>
                                <div className={css.editRemoveBtnDiv}>
                                  <InlineTextButton
                                    type="button"
                                    onClick={handleRefEdit.bind(null, indx, savedDetails)}
                                  >
                                    <FiEdit3 />
                                    <span>{editBtnLabel}</span>
                                  </InlineTextButton>
                                  <InlineTextButton
                                    type="button"
                                    onClick={checkAndRemoveRef.bind(null, indx, {})}
                                  >
                                    <FiMinus />
                                    <span>{removeBtnLabel}</span>
                                  </InlineTextButton>
                                </div>
                              </>
                            )}
                          </div>
                          <span className={css.jobTitle}>{jobTitle}</span>
                          <p className={css.companyName}>{companyName}</p>
                          {!!email && (
                            <div className={css.emailDiv}>
                              <HiOutlineMail />
                              <span>{email}</span>
                            </div>
                          )}
                          <div className={css.phonrNoDiv}>
                            <PhoneIcon />
                            <span>
                              {phoneNumber.dialCode} {phoneNumber.number}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                );
              });
            }}
          </FieldArray>
        </div>

        <InlineTextButton type="button" className={css.addMoreJobBtn} onClick={addMoreRef}>
          <BsPlusLg className={css.icon} />
          <span className={css.text}>{addRefBtnLabel}</span>
        </InlineTextButton>
      </div>
    </React.Fragment>
  );
};

FieldReferenceComponent.defaultProps = {
  rootClassName: null,
  className: null,
  titleClassName: null,
  errorClassName: null,
  userNativeLang: languageSelectOptions.en.value,
  values: [],
  formError: {},
};

FieldReferenceComponent.propTypes = {
  rootClassName: string,
  className: string,
  errorClassName: string,
  titleClassName: string,
  onChange: func,

  // Label is optional, but if it is given, an id is also required so
  // the label can reference the input in the `for` attribute
  id: string.isRequired,
  name: string.isRequired,

  formApi: object.isRequired,
  userNativeLang: oneOf(nativeLangOptions).isRequired,
  formError: object.isRequired,
};

const FieldReferenceComp = injectIntl(FieldReferenceComponent);

const FieldReference = props => {
  return <FieldReferenceComp {...props} />;
};

export default FieldReference;
